import type { HelpZettelStatus } from '@/types/help'
import { useTalkT } from '@/talk/useTalkT'

export function HelpZettelStatus({
  status,
  light = false,
}: {
  status: HelpZettelStatus | string
  light?: boolean
}) {
  const t = useTalkT()
  const wrap = `help-status ${light ? 'help-light-status' : ''}`
  if (status === 'bitte_bestaetigen') {
    return <span className={wrap}><span className="help-orange">{t('talk_confirm_status').toUpperCase()}</span></span>
  }
  if (status === 'rueckfrage') {
    return <span className={wrap}><span className="help-orange">{t('talk_followup').toUpperCase()}</span></span>
  }
  if (status === 'wartet') {
    return <span className={wrap}><span className="help-grey">{t('talk_waiting_net').toUpperCase()}</span></span>
  }
  if (status === 'erledigt') {
    return (
      <span className={wrap}>
        <span className={light ? 'help-green-plain' : 'help-green'}>{t('talk_done').toUpperCase()}</span>
      </span>
    )
  }
  if (status === 'in_arbeit') {
    return (
      <span className={wrap}>
        <span className="help-status-word">{t('talk_in_progress').toUpperCase()}</span>
        <svg className="help-sinus" viewBox="0 0 220 20" aria-hidden>
          <path d="M2 7 C 22 7, 32 2, 52 7 S 82 12, 102 7 S 132 2, 152 7 S 182 12, 202 7 S 218 4, 218 7" />
          <path className="b" d="M2 11 C 22 11, 32 16, 52 11 S 82 6, 102 11 S 132 16, 152 11 S 182 6, 202 11 S 218 14, 218 11" />
        </svg>
      </span>
    )
  }
  return null
}
